import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const kategoriWebOptions = ["Semua", "Nasional", "Internasional", "Ekonomi", "Teknologi"];
const kategoriOptions = ["Semua", "analisis", "opini"];

const Editorial = () => {
  const [dataList, setDataList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState<any>(null);

  const [kategoriWeb, setKategoriWeb] = useState("Semua");
  const [kategori, setKategori] = useState("Semua");
  const [search, setSearch] = useState("");

  const fetchData = async () => {
    setLoading(true);

    try {
      const params: any = {
        page,
        per_page: 5,
      };

      if (kategoriWeb !== "Semua") {
        params.kategori_web = kategoriWeb;
      }

      if (kategori !== "Semua") {
        params.kategori = kategori;
      }

      if (search) {
        params.search = search;
      }

      const res = await axios.get(`${API_BASE}/api/editorial`, { params });

      setDataList(res.data.data);
      setMeta(res.data.meta);
    } catch (err) {
      console.error("Gagal ambil editorial:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, kategoriWeb, kategori]);

  // const stripHtml = (html: string, max = 80) => {
  //   const div = document.createElement("div");
  //   div.innerHTML = html;
  //   const text = div.textContent || "";
  //   return text.length > max ? text.slice(0, max) + "..." : text;
  // };

  return (
    <div className="mt-6">
      {/* HEADER */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
        <h2 className="text-2xl font-bold text-primary">Manajemen Editorial</h2>

        <div className="flex flex-wrap gap-2 items-center">
          {/* SEARCH */}
          <input
            type="text"
            placeholder="Cari judul..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setPage(1);
                fetchData();
              }
            }}
            className="border px-3 py-2 rounded-lg text-sm"
          />

          {/* FILTER KATEGORI */}
          <select
            value={kategori}
            onChange={(e) => {
              setPage(1);
              setKategori(e.target.value);
            }}
            className="border rounded-lg px-3 py-2 text-sm">
            {kategoriOptions.map((opt) => (
              <option key={opt}>{opt}</option>
            ))}
          </select>

          {/* FILTER KATEGORI WEB */}
          <select
            value={kategoriWeb}
            onChange={(e) => {
              setPage(1);
              setKategoriWeb(e.target.value);
            }}
            className="border rounded-lg px-3 py-2 text-sm">
            {kategoriWebOptions.map((opt) => (
              <option key={opt}>{opt}</option>
            ))}
          </select>

          <Link to="/dashboard/editorial/tambah" className="bg-primary hover:bg-primary text-white px-4 py-2 rounded-lg text-sm">
            + Tambah Editorial
          </Link>
        </div>
      </div>

      {/* TABLE */}
      <div className="overflow-x-auto bg-white rounded-xl shadow border">
        <table className="min-w-full text-sm">
          <thead className="bg-primary text-white">
            <tr>
              <th className="p-3 text-left">Judul</th>
              <th className="p-3 text-left">Gambar</th>
              <th className="p-3 text-left">Kategori</th>
              <th className="p-3 text-left">Kategori Web</th>
              <th className="p-3 text-left">Views</th>
              <th className="p-3 text-left">Tanggal</th>
              <th className="p-3 text-left">Aksi</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="p-4 text-center">
                  Loading...
                </td>
              </tr>
            ) : dataList.length === 0 ? (
              <tr>
                <td colSpan={7} className="p-4 text-center text-gray-500">
                  Tidak ada data
                </td>
              </tr>
            ) : (
              dataList.map((item) => (
                <tr key={item.id} className="border-t hover:bg-red-50">
                  <td className="p-3 font-medium">{item.judul.length > 30 ? item.judul.substring(0, 30) + "..." : item.judul}</td>

                  <td className="p-3">{item.gambar ? <img src={item.gambar} alt={item.judul} className="w-24 h-16 object-cover rounded border" /> : "-"}</td>

                  <td className="p-3 capitalize">{item.kategori}</td>

                  <td className="p-3">
                    <span className="bg-red-100 text-red-700 px-2 py-1 rounded text-xs">{item.kategori_web}</span>
                  </td>

                  <td className="p-3">{item.views}</td>

                  <td className="p-3">{new Date(item.created_at).toLocaleDateString()}</td>

                  <td className="p-3">
                    <Link to={`/dashboard/editorial/detail/ ${item.id}`} className="text-primary hover:underline">
                      Detail
                    </Link>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      {meta && (
        <div className="flex justify-between items-center mt-4 text-sm">
          <span className="text-gray-600">
            Page {meta.current_page} dari {meta.last_page} | Total {meta.total}
          </span>

          <div className="flex gap-2">
            <button disabled={page === 1} onClick={() => setPage(page - 1)} className="px-3 py-1 rounded border disabled:opacity-50 hover:bg-red-100">
              Prev
            </button>

            <button disabled={page === meta.last_page} onClick={() => setPage(page + 1)} className="px-3 py-1 rounded border disabled:opacity-50 hover:bg-red-100">
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Editorial;
